import { useQuery } from 'react-query';
import { useClientId } from '../../../../_hooks/useClientId';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { Donor, GivingStrategy, KindOfProperty } from './useCharitableGivingQuery';

export interface AccountDTO {
  id: string;
  name: string;
  institution: string | null;
  balance: number;
}

interface FetcherParams {
  clientId: number;
  givingStrategy: GivingStrategy | null;
  kindOfProperty: KindOfProperty | null;
  donor: Donor | null;
}

export const fetchAccounts = async ({
  clientId,
  givingStrategy,
  kindOfProperty,
  donor,
}: FetcherParams): Promise<AccountDTO[]> => {
  return authFetch(
    urlWithParams(
      '/Consumer/CharitableGivingWorkflow/Accounts',
      {
        clientId,
        strategy: givingStrategy,
        kindOfProperty,
        donor,
      },
      { skipNulls: true },
    ),
  );
};

interface Params {
  givingStrategy: GivingStrategy | null;
  kindOfProperty: KindOfProperty | null;
  donor: Donor | null;
}

export const useAccountsQuery = ({ givingStrategy, kindOfProperty, donor }: Params) => {
  const clientId = useClientId();

  return useQuery(
    queryKeys.accounts(clientId, givingStrategy, kindOfProperty, donor),

    () => fetchAccounts({ clientId, givingStrategy, kindOfProperty, donor }),

    {
      cacheTime: 0,
      enabled: givingStrategy !== null,
    },
  );
};
